import i18next from 'i18next';
import numbro from 'numbro';
import numbroLanguages from 'numbro/dist/languages.min.js';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { loadScript } from "./utils.js";


export let locale = {
    lang: "fr",
    date: {
        defaultFormat: "DD/MM/YYYY",
        shortFormat: "DD/MM/YY",
        monthDayFormat: "DD/MM",
        timeFormat: "HH:mm",
        datetimeFormat: "DD/MM/YYYY HH:mm",
    },
    number: {
        delimiters: {
            decimal: ",",
            thousands: " "
        }
    }
};

function momentLocaleCode(lang) {
    var availableLocales = ["af", "ar-dz", "ar", "ar-kw", "ar-ly", "ar-ma", "ar-sa", "ar-tn", "az", "be", "bg", "bn", "bo", "br", "bs", "ca", "cs", "cv", "cy", "da", "de-at", "de-ch", "de", "dv", "el", "en-au", "en-ca", "en-gb", "en-ie", "en-nz", "eo", "es-do", "es", "et", "eu", "fa", "fi", "fo", "fr-ca", "fr-ch", "fr", "fy", "gd", "gl", "gom-latn", "he", "hi", "hr", "hu", "hy-am", "id", "is", "it", "ja", "jv", "ka", "kk", "km", "kn", "ko", "ky", "lb", "lo", "lt", "lv", "me", "mi", "mk", "ml", "mr", "ms", "ms-my", "my", "nb", "ne", "nl-be", "nl", "nn", "pa-in", "pl", "pt-br", "pt", "ro", "ru", "sd", "se", "si", "sk", "sl", "sq", "sr-cyrl", "sr", "ss", "sv", "sw", "ta", "te", "tet", "th", "tlh", "tl-ph", "tr", "tzl", "tzm", "tzm-latn", "uk", "ur", "uz", "uz-latn", "vi", "x-pseudo", "yo", "zh-cn", "zh-hk", "zh-tw"];
    lang = lang.replace("_", "-").toLowerCase();

    if (availableLocales.indexOf(lang) !== -1) {
        return lang;
    }

    if (availableLocales.indexOf(lang.substring(0, 2)) !== -1) {
        return lang.substring(0, 2);
    }

    return "en";
}
function numbroLocaleCode(lang) {
    lang = lang.replace("_", "-");

    if (numbroLanguages[lang]) {
        return lang;
    }

    let foundLang = null;
    Object.keys(numbroLanguages).some(function(l){
        if(l.indexOf(lang.substring(0, 2)) === 0){
            foundLang = l ;
        }
    }) ;

    if(foundLang){
        return foundLang ;
    }

    return "en-GB";
}

const loadedLocales = {} ;
function loadMomentLocal(lang){
    if(lang === "en" || loadedLocales[lang]){
        return Promise.resolve() ;
    }
    let url = "/node_modules/moment/locale/"+lang+".js";
    if(window.isCordova){
        url = "node_modules/moment/locale/"+lang+".js";
    }
    return loadScript(url).then(()=>{
        loadedLocales[lang] = true ;
    }) ;
}

export function setLocale(lang) {
    try{
        localStorage.setItem("lang", lang) ;
    }catch(err){
        console.warn("Can't access to local storage", err) ;
    }
    return new Promise((resolve, reject)=>{
        const momentLang = momentLocaleCode(lang);
        const numbroLang = numbroLocaleCode(lang);
        const moment = window.moment ;
        window.now = ()=>{ return moment().format("YYYY-MM-DDTHH:mm:ss.SSS") ; } ;
        loadMomentLocal(momentLang).then(()=>{
            let momentLocale = moment.localeData(momentLang);
            let numbroLocale = numbroLanguages[numbroLang];
            locale.lang = lang;
            locale.date = {
                defaultFormat: momentLocale._longDateFormat.L,
                shortFormat: momentLocale._longDateFormat.L.replace("YYYY", "YY"),
                monthDayFormat: momentLocale._longDateFormat.L.replace("/YYYY", ""),
                timeFormat: momentLocale._longDateFormat.LT,
                datetimeFormat: momentLocale._longDateFormat.L + " " + momentLocale._longDateFormat.LT,
    
            };
            locale.number= {
                delimiters: {
                    decimal: numbroLocale.delimiters.decimal,
                    thousands: numbroLocale.delimiters.thousands
                }
            };
            moment.locale(momentLang);
            numbro.registerLanguage(numbroLocale) ;
            numbro.setLanguage(numbroLang);
            i18next.changeLanguage(lang, function(err){
                if(err){ return reject(err) ;}
                resolve() ;
            });    
        }) ;
    }) ;
}

export function getCurrentLang(){
    return i18next.language ;
}

export function tr() {
    return i18next.t.apply(i18next, arguments);
}

export function translateElement(el){
    var elements = el.querySelectorAll("[data-i18n]");
    var regexpAttr = /^\[(.*)](.*)$/;
    for(var i=0; i<elements.length; i++){
        var str = elements[i].getAttribute("data-i18n") ;
        var match ;
        if((match = regexpAttr.exec(str)) !== null) {
            var attr = match[1] ;
            var code = match[2] ;
            elements[i].setAttribute(attr, tr(code)) ;
        }else{
            elements[i].innerHTML = tr(str) ;
        }
    }
}

export function configure(options) {
    return new Promise((resolve)=>{
        var opts = {
            fallbackLng: 'en',
            detection: {
                order: ['querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],
            },
            backend: {
                loadPath: '/static/locales/{{lng}}.json',
            }
        };
        Object.keys(options).forEach(function (k) {
            opts[k] = options[k];
        });
    
        i18next.use(XHR);
        i18next.use(LanguageDetector);
        i18next.init(opts, function (err) {
            console.debug("i18next init done");
            if (err) {
                //just warn some files are missing, fallback will handle resolution to fallback lang
                console.warn("Some translation file are missing", err);
                return resolve() ;
            }
    
            let storedLang = null;
            try{
                storedLang = localStorage.getItem("lang") ;
            }catch(err){
                console.warn("Can't access to local storage", err) ;
            }
            if(storedLang){
                setLocale(storedLang).then(()=>{ resolve() ; }) ;
            }else{
                setLocale( i18next.language).then(()=>{ resolve() ; }) ;
            }
    
        });
    }) ;
}

export function getTr(options) {
    return new Promise((resolve, reject)=>{
        var opts = {
            fallbackLng: 'en',
            detection: {
                order: ['querystring', 'navigator', 'htmlTag', 'path', 'subdomain'],
            },
            backend: {
                loadPath: '/static/locales/{{lng}}.json',
            }
        };
        Object.keys(options).forEach(function (k) {
            opts[k] = options[k];
        });

        const newInstance = i18next.createInstance();
        newInstance.use(XHR);

        newInstance.init(opts, (err, t) => {
            if(err){ return reject(err) ;}
            resolve(t) ;
            // newInstance.changeLanguage(options.lng, function(err){
            //     if(err){ return reject(err) ;}
                // resolve(function tr() {
                //     return newInstance.t.apply(newInstance, arguments);
                // }) ;
            // });    
        });
    }) ;
}